import React from 'react'
import styled from 'styled-components'
import { BoldText, ExtraBold } from 'shared/textStyles'
import { breakPoints } from 'shared/breakPoints'
import delilaHeadshot from 'images/delila.jpg'
import austinHeadshot from 'images/austin.jpg'
import clintonHeadshot from 'images/clinton.jpg'
import dougHeadshot from 'images/doug.jpg'
import loukasHeadshot from 'images/jeff-l.jpg'
import jeffHeadshot from 'images/jeff-d.jpg'
import stefanHeadshot from 'images/stefan.jpg'
import marcusHeadshot from 'images/marcus.jpg'
import quinnHeadshot from 'images/quinn.jpg'

export const Delila = props => (
  <InfoContainer>
    <img
      src={delilaHeadshot}
      alt="Delila"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>Delila Lee</ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Software Engineer
    </BoldText>
  </InfoContainer>
)

export const Marcus = props => (
  <InfoContainer>
    <img
      src={marcusHeadshot}
      alt="Marcus"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>
      Marcus Oladell
    </ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Senior Software Engineer
    </BoldText>
  </InfoContainer>
)

export const Quinn = props => (
  <InfoContainer>
    <img
      src={quinnHeadshot}
      alt="Quinn"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>
      Quinn Harris
    </ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Senior Software Engineer
    </BoldText>
  </InfoContainer>
)

export const Doug = props => (
  <InfoContainer>
    <img
      src={dougHeadshot}
      alt="Doug Kirk"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>Doug Kirk</ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Software Engineer
    </BoldText>
  </InfoContainer>
)

export const Stefan = props => (
  <InfoContainer>
    <img
      src={stefanHeadshot}
      alt="Stefan Age"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>Stefan Age</ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Front End Developer
    </BoldText>
  </InfoContainer>
)

export const Austin = props => (
  <InfoContainer>
    <img
      src={austinHeadshot}
      alt="Austin"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>
      Austin Russell
    </ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Machine Learning Engineer
    </BoldText>
  </InfoContainer>
)

export const Jeff = props => (
  <InfoContainer>
    <img
      src={jeffHeadshot}
      alt="Jeff Davis"
      style={{ width: 150, borderRadius: 5 }}
    />
    <ExtraBold style={{ marginBottom: 0, marginTop: 16 }}>
      Jeffrey Davis
    </ExtraBold>
    <BoldText color="novo-dark-gray" style={{ marginTop: 8 }}>
      Director Of Engineering
    </BoldText>
  </InfoContainer>
)

export const Clinton = props => (
  <FounderInfoContainer>
    <FounderImage src={clintonHeadshot} alt="Clinton Coleman" />
    <div>
      <FounderName>Clinton Coleman</FounderName>
      <FounderTitle color="novo-dark-gray">
        Co-Founder and Chief Executive Officer
      </FounderTitle>
      <p
        style={{
          textAlign: 'justify',
          color: 'var(--novo-dark-gray)',
          maxWidth: 600,
          margin: 'auto',
        }}
      >
        Clinton has been an investor, director, and CEO of several
        publicly-traded and private companies during the past fifteen years,
        including roles with restaurant and retail companies. As emerging
        technologies have created new frontiers for how intelligent systems can
        interact with live consumer environments, Clinton saw an opportunity to
        partner with a strong technologist to start a company to develop new
        business process solutions utilizing artificial intelligence
        capabilities.
      </p>
    </div>
  </FounderInfoContainer>
)

export const Loukas = props => (
  <FounderInfoContainer>
    <FounderImage src={loukasHeadshot} alt="Jeff Loukas" />
    <div>
      <FounderName>Jeff Loukas</FounderName>
      <FounderTitle color="novo-dark-gray">
        Co-Founder and Chief Product Officer
      </FounderTitle>
      <p
        style={{
          textAlign: 'justify',
          color: 'var(--novo-dark-gray)',
          maxWidth: 600,
          margin: 'auto',
        }}
      >
        Jeff has led digital product teams in the hospitality, airline,
        restaurant and telecom industries for the past seventeen years. He has
        driven the strategy, development, and operations of the digital
        transaction channels in each of these verticals, leading people,
        process, and product innovation along the way. Jeff’s experience
        managing the deployment of artificial intelligence into new consumer
        interfaces led him to a broader vision of using those new tools to
        optimize the consumer experience.
      </p>
    </div>
  </FounderInfoContainer>
)

const InfoContainer = styled.div`
  padding: 16px;
  min-height: 400;
  text-align: center;
`

const FounderInfoContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: column;
  margin: 16px 0 32px 0;
  padding: 16px;

  @media ${breakPoints.desktop} {
    flex-direction: row;
  }
`

const FounderImage = styled.img`
  alt: ${props => (props.alt ? `${props.alt}` : null)};
  align-self: center;
  border-radius: 5px;
  height: 225px;
  src: ${props => (props.src ? `${props.src}` : null)};
  width: 150px;

  @media ${breakPoints.desktop} {
    margin-right: 16px;
  }
`

const FounderName = styled.h4`
  color: ${props =>
    props.color ? `var(--${props.color})` : 'var(--novo-green)'};
  font-family: 'Pangram Extra Bold';
  font-size: ${props => (props.size ? `${props.size}px` : null)};
  margin-bottom: 8px;
  text-align: ${props => (props.alignment ? `${props.alignment}` : 'center')};
  width: 100%;

  @media ${breakPoints.desktop} {
    text-align: left;
  }
`

const FounderTitle = styled.p`
  color: ${props =>
    props.color ? `var(--${props.color})` : 'var(--novo-green)'};
  font-family: 'Pangram Bold';
  margin-top: 0;
  text-align: ${props => (props.alignment ? `${props.alignment}` : 'center')};

  @media ${breakPoints.desktop} {
    text-align: left;
  }
`



// WEBPACK FOOTER //
// ./src/components/PersonnelInfo.js